import axios from 'axios';

export default {
    name: 'q-system-message',
    // Props provided from the main Login.vue component.
    props: ['message', 'token'],
    // Initial data.
    data() {
        return {
            classes: 'system-message banner',
            position: null,
            type: this.message.template
        };
    },
    // After the component is created but not rendered (mounted).
    created() {
        if (this.message.template.match(/_/)) {
            // Split template name and position.
            let splitTemplatName = this.message.template.split('_');

            // Set template and position values on component data object.
            this.type = splitTemplatName[0];
            this.position = splitTemplatName[1];
        }
    },
    // After the component is rendered.
    mounted() {
        // Add class to body to adjust other elements for system message.
        this.toggleBodyClass('add', `system-message-${this.type}`);
    },
    // Methods for this component.
    methods: {
        // Close the system message on click of close icon.
        onClickCloseBanner() {
            // Remove the body class we used for manipulating other elements.
            this.toggleBodyClass('remove', `system-message-${this.type}`);

            // Emit the system message as null to elimate the component.
            this.$emit('updateSystemMessageTransition', 'component-slide-up');
            this.$emit('updateSystemMessage', null);

            // Submit an API request to mark the system message as read.
            axios
                .post(
                    `${process.env.VUE_APP_QV3_API}/systemmessages/${
                        this.message.id
                    }/read`,
                    {
                        headers: {
                            'X-Api-Key': this.token
                        }
                    }
                )

                // After getting a successful response for marking the message read.
                .then(() => {})

                // If the request failed.
                .catch(() => {});
        },
        // Toggle the body class for manipulating other elements.
        toggleBodyClass(action, className) {
            const bodyElement = document.body;

            if (action === 'add') {
                bodyElement.classList.add(className);
            } else {
                bodyElement.classList.remove(className);
            }
        }
    }
};
